import { FC, useState, useEffect } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Box, Card, Button, Dialog, useMediaQuery, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import theme from 'themes/lightTheme';
import DeleteDialog from 'components/DeleteDialog';
import { deleteSchedulerRoiTypeLimitsItem, getSchedulerRoiTypeLimits, getSchedulerRoomsRoiTypeLimits } from 'api/schedulersettings';
import SchedulerRoiTypesImportDialog from './SchedulerRoiTypeLimitsImportDialog';
import SchedulerRoiTypesTable from './SchedulerRoiTypeLimitsTable';
import SchedulerRoomsFilter from 'components/SchedulerRoomFilter/SchedulerRoomFilter';
import { SchedulerQueryKeys } from 'constants/QueryKeys/schedulerKeys';
import { loadOnceConfig } from 'constants/QueryKeys/queryConfig';

/**
 * Вкладка с сеткой ROI в расписаторе.
 */
const SchedulerRoiTypeLimits: FC = () => {
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const defaultValue = "Default";

    const [filter, setFilter] = useState([defaultValue]);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [importDialog, setImportDialog] = useState(false);

    const selectRoom = filter[0] ?? defaultValue;
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!filter[0]) {
            setFilter([defaultValue]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    const { data: rooms } = useQuery(SchedulerQueryKeys.roiTypeLimitsNetworks(), getSchedulerRoomsRoiTypeLimits, loadOnceConfig)

    const { data: roiTypesData } = useQuery(SchedulerQueryKeys.roiTypeLimits(selectRoom), getSchedulerRoiTypeLimits, loadOnceConfig)

    const delItemMutation = useMutation(deleteSchedulerRoiTypeLimitsItem, {
        onSuccess: () => {
            queryClient.invalidateQueries(SchedulerQueryKeys.ROI_TYPE_LIMITS_NETWORKS_KEY);
            queryClient.invalidateQueries(SchedulerQueryKeys.ROI_TYPE_LIMITS_KEY);
            setFilter([defaultValue]);
        },
    });

    function deliteItem(network: string) {
        delItemMutation.mutate(network);
        setDeleteDialog(false);
    }

    return (
        <>
            <Box className='flex flex-row justify-between gap-2 items-center'>
                <Box>
                    {rooms && rooms.networks && <SchedulerRoomsFilter setFilter={setFilter} data={filter} rooms={rooms.networks} />}
                </Box>
                <Box>
                    <Button variant="contained" size='large' type='submit' endIcon={<ImportExportIcon />} onClick={() => setImportDialog(true)} className="mr-2">
                        Импорт
                    </Button>
                    <Button variant="outlined" size='large' type='submit' color="error" startIcon={<DeleteIcon />} onClick={() => setDeleteDialog(true)}>
                        Удалить
                    </Button>
                </Box>
            </Box>
            {roiTypesData && roiTypesData.limits && (
                <Box className="mt-4">
                    <Typography variant='h6' className='mb-1'>ROI Types</Typography>
                    <Card>
                        <SchedulerRoiTypesTable items={roiTypesData.limits} />
                    </Card>
                </Box>
            )}
            <Dialog fullWidth maxWidth='md' open={importDialog} onClose={() => setImportDialog(false)} fullScreen={fullScreen} >
                <SchedulerRoiTypesImportDialog close={() => setImportDialog(false)} active={filter} />
            </Dialog>
            <DeleteDialog close={() => setDeleteDialog(false)} open={deleteDialog} loading={false} handleAgreeAction={() => deliteItem(filter[0])} />
        </>
    );
}

export default SchedulerRoiTypeLimits;
